import {useSelector} from 'react-redux';
import {mediumScreen} from '../globalVariables/GlobalVariables';

const useMediumScreen = () => {
    return useSelector(s => s.ui.windowWidth < mediumScreen);
};

export default useMediumScreen;

